import Resumable from 'resumablejs';
import template from './MassAssignMediaUploadComponent.html';
import MediaUploadComponent from '../MediaUpload/MediaUploadComponent';

export default {
  template,

  extends: MediaUploadComponent,

  props: {
    relatedModel: {
      type: String,
      required: false,
    },
    relatedId: {
      type: Number,
      required: false,
    },
  },

  data() {
    return {
      resumable: new Resumable({
        target: '/admin/api/v1/upload/sendChunk',
        testChunks: false,
        prioritizeFirstAndLastChunk: false,
        forceChunkSize: true,
        chunkSize: 5 * 1024 * 1024,
        simultaneousUploads: this.totalSimultaneousUploads,
        maxFiles: this.maxFilesToUpload,
        throttleProgressCallbacks: 1,
        // Fix Axios interceptor overriding header vars:
        headers: () => ({
          Accept: 'application/json, text/plain, */*',
          'X-CSRF-TOKEN': window.Laravel.csrfToken,
          'X-Requested-With': 'XMLHttpRequest',
        }),
      }),
    };
  },

  methods: {
    finishRequest(id) {
      const file = this.getFile(id);

      axios.post('/admin/api/v1/upload/finishUploadAndAssign', {
        uploadId: file.uploadId,
        fileName: file.fileName,
        name: file.name,
        etags: file.etags,
        siteId: this.site_id,
        usedWithGalleryModule: this.usedWithGalleryModule,
        relatedModel: this.relatedModel,
        relatedId: this.relatedId,
        type: this.type,
        role: this.role,

        // Parameters for image options
        image_options: this.imageOptions,
      }).then(
        (response) => {
          this.files = this.files.map((fileItem) => {
            if (fileItem.id === file.id) {
              fileItem.completed = true;
              fileItem.url = response.data.url;
              // Update id of file in order to allow delete requests
              fileItem.id = response.data.id;
              fileItem.created_at = response.data.created_at;

              // Attributes for related product, if found
              fileItem.relation_id = response.data.relation_id;
              fileItem.relation_type = response.data.relation_type;

              if (response.data.file_type === 'image') {
                this.addImageNewFile(response.data);
                this.$emit('image:upload', response.data);
              } else {
                this.addDocumentNewFile(response.data);
                this.$emit('document:upload', response.data);
              }
            }

            return fileItem;
          });
        }, (error) => {
        },
      );
    },
  },
};
